<template>
  <md-layout md-column md-gutter>
    <md-toolbar class="md-transparent">
      <img src="../assets/Insilico_logo.svg" class="top_logo"/>

      <h2 class="md-title" style="flex: 1">&nbsp;</h2>
      <ul class="top_menu">
        <li><a href="#" v-scroll-to="'#about'">About</a></li>
        <li><a href="#"  v-scroll-to="'#contacts'">Contacts</a></li>
        
        <li v-if="isAuth"><router-link to="profile">Profile</router-link></li>
        <li v-if="isAuth"><a href="#"  @click='performLogout'>Logout</a></li>
        <li v-else><a href="#"  v-scroll-to="'#login'">Login</a></li>
        
      </ul>
    </md-toolbar>
    
    <md-layout class="main_img">
     
    </md-layout>
    
    <md-layout  md-align="center" id="login" style="margin-top:50px;">
   <md-layout md-flex="70" class="user_form_container" >
      <user-form class="userf"></user-form>
   </md-layout>
   </md-layout>
    
    <md-layout class="how_it_works"  md-align="center">
      <h2>HOW IT WORKS</h2>
    </md-layout>
    
    <md-layout  md-align="center" md-vertical-align="top" md-gutter>
       
	    <md-layout md-flex="15" md-align="center" md-column class="how_box" >
	      <div class="how_box_icon icon1" ></div>
	      <div class="how_box_header">REGISTER</div>
	      <div class="how_box_text">Enter some information about your experience in medicinal chemistry for further analysis
	       <br/>&nbsp; <br/>&nbsp;
	        </div>
	    </md-layout>
	    <md-layout md-flex="15" md-align="center"  md-column  class="how_box">
	      <div class="how_box_icon icon2" ></div>
	      <div class="how_box_header">SELECT TEST</div>
	      <div class="how_box_text">Select a type of the experiment to run:<br/>
                                    - using EMOTIV device<br/>
                                    - or without it
                                     <br/>&nbsp; <br/>&nbsp;</div>
	    </md-layout>
	    <md-layout md-flex="15" md-align="center" md-column class="how_box">
	      <div class="how_box_icon icon3" ></div>
	      <div class="how_box_header">TAKE THE TEST</div>
	      <div class="how_box_text">Look at the molecules and Like/Dislike or Look at the molecules and guess 
	      if the molecule is designed by the GAN or another medicinal chemistct
	     </div>
	    </md-layout>
	    <md-layout md-flex="15" md-align="center" md-column  class="how_box">
	      <div class="how_box_icon icon4" ></div>
	      <div class="how_box_header">GET A REPORT</div>
	      <div class="how_box_text">We are working on immediate reporting You will get a comprehensive report after several medicinal chemists join the experiment</div>
	    </md-layout>
	    
    </md-layout>
    
    <md-layout  md-align="center" md-vertical-align="center"  class="l_what_is" id="about">
      <md-layout md-flex="45"  md-column class="what_is_container">
        <md-toolbar class="md-transparent" style="padding: 30px;">
          <h2 class="md-title" style="flex: 1">WHAT IS CHEMISTRY.AI </h2>
         <md-button class="md-fab md-mini open-button" @click="show_what_is = !show_what_is" >
           <md-icon v-if="show_what_is">close</md-icon>
           <md-icon v-else >add</md-icon>
         </md-button>
       </md-toolbar>
       
       <transition name="slide-fade">
       <md-layout class="l_about" v-show="show_what_is">
 
          <p>
     		Medicinal chemistry is among one of the most important and intellectually-challenging professions on the planet. It takes decades of training and experience to learn the properties of the thousands of molecules and their effects on the biological systems, model organisms and diseases. Decisions made by the medicinal chemists affect the lives of billions of people and may result in the billions of dollars of gains or losses by the pharmaceutical companies. 
          </p><p>
          Experienced medicinal chemists have the ability to accurately describe the properties and the possible effects of the molecule just by looking at its structure as well as at the various numerical parameters. 
		</p><p>
		Medicinal chemists may like or dislike certain molecular structures because of their experience with the hundreds or thousands of molecules they encountered previously and the emotional response to the molecule is usually biased and related to the molecules and the classes of molecules they are most familiar with. 
		</p><p>
		Chemistry.AI will provide a platform for the medicinal chemists to look at the various classes of molecules and measure their brain activity and other physiological parameters during the exposure to the molecule. 
		</p><p>
		The system is intended to answer the following questions: 
 		</p>
 		<ol>
		<li> Can a medicinal chemist have a ”hunch” about the good or bad molecule?</li>

		<li>Can a medicinal chemist predict the outcome of a clinical trial by just looking at the molecule? </li>

		<li> Can we create a test to compare medicinal chemists using 1 & 2 questions?</li>

		<li> Can the medicinal chemist distinguish the molecules created by the human medicinal chemists from those generated by artificial intelligence (A.I.)</li>

		<li> Can we use the top-performing medicinal chemists as discriminators for training the deep neural networks?</li>

		<li> Can we pinpoint the are a of the brain responsible for recognizing the good molecules?</li>
 
 
 		</ol>  
   
   		</p>
        
        </md-layout>
        </transition>
       
       
     </md-layout>
   </md-layout>
   
   
  <md-layout md-align="center" style="min-height: 500px; margin: 100px 0 150px 0;">
    <iframe width="60%" height="300" src="https://www.youtube.com/embed/0SyZQGfcuho"></iframe>
  
  </md-layout>
  
  <md-layout  class="footer" id="contacts">
  <md-layout md-flex="50" >
      <div class="google-map" id="google_map"></div>
  </md-layout>
    <md-layout md-flex="50" md-column class="l_contacts">
      <strong>Insilico Medicine</strong> 
      <p>
      Rm 8, Unit 111-113 <br/>
      ICT Co-Working Centre <br/>
      1/F Enterprise Place<br/>
      5 Science Park West Avenue, Hong Kong<br/><br/>

     <strong>Email:</strong> zhu(at)insilicomedicine.com<br/>
     </p>
    
    </md-layout>
    <md-toolbar class="md-transparent footer-toobar">
      

      <h2  style="flex: 1">© 2017-{{current_year}} All Right Reserved. Insilico Medicine, Inc.</h2>
      <ul class="bottom_menu">
        <li><a href="https://www.facebook.com/insilicomedicine" target="_blank"> <svg class="t-sociallinks__svg" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="30px" height="30px" viewBox="0 0 48 48" enable-background="new 0 0 48 48" xml:space="preserve"><desc>Facebook</desc><path style="fill:#000000;" d="M47.761,24c0,13.121-10.638,23.76-23.758,23.76C10.877,47.76,0.239,37.121,0.239,24c0-13.124,10.638-23.76,23.764-23.76C37.123,0.24,47.761,10.876,47.761,24 M20.033,38.85H26.2V24.01h4.163l0.539-5.242H26.2v-3.083c0-1.156,0.769-1.427,1.308-1.427h3.318V9.168L26.258,9.15c-5.072,0-6.225,3.796-6.225,6.224v3.394H17.1v5.242h2.933V38.85z"/></svg> </a></li>
        <li><a href="https://twitter.com/InSilicoMeds" target="_blank"> <svg class="t-sociallinks__svg" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="30px" height="30px" viewBox="0 0 48 48" enable-background="new 0 0 48 48" xml:space="preserve"><desc>Twitter</desc><path style="fill:#000000;" d="M47.762,24c0,13.121-10.639,23.76-23.761,23.76S0.24,37.121,0.24,24c0-13.124,10.639-23.76,23.761-23.76 S47.762,10.876,47.762,24 M38.031,12.375c-1.177,0.7-2.481,1.208-3.87,1.481c-1.11-1.186-2.694-1.926-4.455-1.926 c-3.364,0-6.093,2.729-6.093,6.095c0,0.478,0.054,0.941,0.156,1.388c-5.063-0.255-9.554-2.68-12.559-6.367 c-0.524,0.898-0.825,1.947-0.825,3.064c0,2.113,1.076,3.978,2.711,5.07c-0.998-0.031-1.939-0.306-2.761-0.762v0.077 c0,2.951,2.1,5.414,4.889,5.975c-0.512,0.14-1.05,0.215-1.606,0.215c-0.393,0-0.775-0.039-1.146-0.109 c0.777,2.42,3.026,4.182,5.692,4.232c-2.086,1.634-4.712,2.607-7.567,2.607c-0.492,0-0.977-0.027-1.453-0.084 c2.696,1.729,5.899,2.736,9.34,2.736c11.209,0,17.337-9.283,17.337-17.337c0-0.263-0.004-0.527-0.017-0.789 c1.19-0.858,2.224-1.932,3.039-3.152c-1.091,0.485-2.266,0.811-3.498,0.958C36.609,14.994,37.576,13.8,38.031,12.375"/></svg> </a></li>
        
        <li ><a href="https://www.youtube.com/channel/UCMUen0Syr66mft-SlDgmv1g/videos" target="_blank"> <svg class="t-sociallinks__svg" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="30px" height="30px" viewBox="-455 257 48 48" enable-background="new -455 257 48 48" xml:space="preserve"><desc>Youtube</desc><path style="fill:#000000;" d="M-431,257.013c13.248,0,23.987,10.74,23.987,23.987s-10.74,23.987-23.987,23.987s-23.987-10.74-23.987-23.987S-444.248,257.013-431,257.013z M-419.185,275.093c-0.25-1.337-1.363-2.335-2.642-2.458c-3.054-0.196-6.119-0.355-9.178-0.357c-3.059-0.002-6.113,0.154-9.167,0.347c-1.284,0.124-2.397,1.117-2.646,2.459c-0.284,1.933-0.426,3.885-0.426,5.836s0.142,3.903,0.426,5.836c0.249,1.342,1.362,2.454,2.646,2.577c3.055,0.193,6.107,0.39,9.167,0.39c3.058,0,6.126-0.172,9.178-0.37c1.279-0.124,2.392-1.269,2.642-2.606c0.286-1.93,0.429-3.879,0.429-5.828C-418.756,278.971-418.899,277.023-419.185,275.093zM-433.776,284.435v-7.115l6.627,3.558L-433.776,284.435z"/></svg> </a> </li>
        <li ><a href="https://www.linkedin.com/company/in-silico-medicine-inc" target="_blank"> <svg class="t-sociallinks__svg" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="30px" height="30px" viewBox="-615 1477 48 48" enable-background="new -615 1477 48 48" xml:space="preserve"><desc>LinkedIn</desc><path style="fill:#000000;" d="M-566.999,1501c0,13.256-10.746,24-24,24c-13.256,0-24.002-10.744-24.002-24c0-13.254,10.746-24,24.002-24C-577.745,1477-566.999,1487.746-566.999,1501z M-605.506,1514.975h6.22v-20.004h-6.22V1514.975z M-602.396,1492.236c1.987,0,3.602-1.615,3.602-3.606c0-1.99-1.615-3.605-3.602-3.605c-1.993,0-3.604,1.615-3.604,3.605C-606,1490.621-604.389,1492.236-602.396,1492.236z M-576,1504.002c0-5.387-1.163-9.529-7.454-9.529c-3.023,0-5.054,1.658-5.884,3.231h-0.085v-2.733h-5.964v20.004h6.216v-9.896c0-2.609,0.493-5.137,3.729-5.137c3.186,0,3.232,2.984,3.232,5.305v9.729H-576V1504.002z"/></svg> </a> </li>
        
        
      </ul>
    </md-toolbar>
  
  </md-layout>
  
  </md-layout>
</template>

<script>
import { mapGetters } from 'vuex'

import Onboarding from './Onboarding'
import UserForm from './UserForm'

export default {
  name: 'mainpage',
  props: ['testClick'],
  components: {
      Onboarding,
      UserForm
    },
  data () {
    return {
      current_year: new Date().getFullYear(),
      show_what_is: false
    }
  },
  computed: {
	  ...mapGetters({
  		isAuth: 'isLoggedIn',
  		currentUser: 'getUser'
  	    }),
	},
  methods: {
  	performLogout() {
			this.$store.dispatch('logout')
			this.$router.push('/');
		},
		redirectProfile(){
			this.$router.push('/profile');
		}
  },
  mounted(){
	  const element = document.getElementById('google_map')
	    const options = {
	      zoom: 14,
	      center: new google.maps.LatLng(22.322527, 114.207675)
	    }
	    const map = new google.maps.Map(element, options);
	    const position = new google.maps.LatLng(22.322527, 114.207675); 
	    const marker = new google.maps.Marker({ 
		    position,
		    map
		  });
  }
}

</script>

<style>
.main_layout {
  background-image: url('../assets/top-element.png'), url('../assets/bottom_element.png');
  background-position:  top left, bottom right ;
  background-repeat: no-repeat, no-repeat;
  

}

.top_logo {
    max-width: 80px; 
    width: 80px;
    height: auto;
    display: block;
    margin: 0 0 0 32px;
}
.top_menu {
     list-style:none;
}
.top_menu li {
    display: inline;
    font-size: 16px;
    color: #000;
    padding: 0 15px;
}
.top_menu li a {
    color:#6e6e6e !important;
    font-weight:600;
}
.top_menu li a:hover {
    text-decoration: none !important;
    color: #000 !important;
}
.main_img {
    min-height: 100vh;
    background-image: url('../assets/quentin_robot_2_logo.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    
    position: relative;
    overflow: hidden;
    background-attachment: scroll;
    

}
.how_it_works{
    margin-bottom: 55px;
}
.how_it_works h2 {
    color:#eb8d00;
    font-size: 2vw;
    line-height: 1.23;
}
.how_box {
    margin: 0 20px;
}
.how_box_icon{
    width: 100px;
    height: 100px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    margin: 0 auto;
}
.icon1 {
    background-image: url('../assets/icon1.svg');
}
.icon2 {
    background-image: url('../assets/icon2.svg');
}
.icon3 {
    background-image: url('../assets/icon3.svg');
}
.icon4 {
    background-image: url('../assets/icon4.svg');
}
.how_box_header {
    color: #f27705;
    margin-top: 15px ;
    text-align: center;
    font-size: 1.5vw;
    line-height: 1.35;
    font-weight: 600;
}
.how_box_text{
    text-align: center;
    margin-top: 15px;
    font-size: 1.2vw;
    font-weight: 300;
    line-height: 1.55;
}
.l_what_is {
    margin: 45px 0 0 0;
    min-height: 105px;
}
.what_is_container {
    background-color: #e36600;
    color: #fff;
    
    height: auto;
    
}
.open-button {
    background-color: #e36600 !important;
}
.open-button:hover {
    background-color: #fff !important;
}
.what_is_container h2 {
    color: #fff;
    font-size: 2vw !important;
    font-weight: 600 !important;
    
}
.l_about {
    margin: 0;
    padding: 0 30px 30px 30px;
    font-size: 1.2vw;
    line-height: 1.55;
}
.footer {
    color: #fff;
    background-color: #6fa930;
    font-size:  1.2vw;
    line-height: 1.55;
}
.google-map {
  width: 100%;
  height: auto;
  margin: 0;
  background: gray;
}
.l_contacts {
    padding: 50px 0 0 50px;
}
.footer {
    margin-top: 0px;
}
.footer-toobar {
    background-color: #e3e3e3 !important;
    border-top: 1px solid;
    border-top-color: #c2c2c2;
    width: 100%;
    padding: 0 50px;
}
.footer-toobar h2 {
    color: #555;
    font-size: 0.8vw;
    font-weight: 300;
}
.bottom_menu {
     list-style:none;
}
.bottom_menu li {
    display: inline;
    font-size: 16px;
    color: #000;
    padding: 0 ;
}
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active до версии 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

</style>


// WEBPACK FOOTER //
// MainPage.vue?a83f6d26